/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Top workout types panel (034 US4) — the workout analog of the Heart Rate Top-5
 * Tags panel, on the shared au-panel/au-card system. Shows the Top 5 workout_type
 * by record count (as returned: count desc, then name), each with its count and its
 * percentage share of Total Records ("—" when Total Records is 0; no divide-by-zero).
 * Null/empty types arrive grouped as "(untyped)". Text + value, tabular numerals.
 *
 * Props: { data:[{workout_type,type_count}], totalRecords:number }
 */
const n = (v) => Number(v || 0).toLocaleString();

const pctShare = (count, total) => {
  if (!total || total <= 0) return '—';
  const p = (Number(count) / total) * 100;
  return p < 1 ? '<1%' : `${Math.round(p)}%`;
};

const WorkoutTopTypesPanel = ({ data = [], totalRecords = 0 }) => (
  <div className="au-panel" data-testid="wk-top-types">
    <div className="au-panel__head">
      <h4 className="au-panel__title">Top workout types</h4>
    </div>
    {Array.isArray(data) && data.length > 0 ? (
      <ul className="wk-toptypes">
        {data.map((t) => (
          <li key={t.workout_type} className="wk-toptypes__row">
            <span className="wk-toptypes__name au-ellipsis">{t.workout_type}</span>
            <span className="wk-toptypes__count tnum">{n(t.type_count)}</span>
            <span className="wk-toptypes__pct tnum">{pctShare(t.type_count, totalRecords)}</span>
          </li>
        ))}
      </ul>
    ) : (
      <div className="au-chart-empty" data-testid="wk-top-types-empty">
        No workout types in this range.
      </div>
    )}
  </div>
);

export default WorkoutTopTypesPanel;
